/**
 * Auth Types
 * User authentication interfaces
 */

/**
 * Authentication modes supported by the application
 */
export enum AuthMode {
  PASSWORD = 'password',
  EMAIL_LINK = 'emailLink',
  PASSWORD_SETUP = 'passwordSetup',
}

/**
 * User interface compatible with both Firebase and Clerk
 */
export interface User {
  /** Unique user identifier */
  uid: string;

  /** User's email address */
  email: string | null;

  /** Display name */
  displayName: string | null;

  /** Profile photo URL */
  photoURL: string | null;

  /** Whether email is verified */
  emailVerified?: boolean;

  /** Phone number */
  phoneNumber?: string | null;

  /** Additional metadata */
  metadata?: {
    creationTime?: string;
    lastSignInTime?: string;
  };
}

/**
 * Email link authentication parameters
 */
export interface EmailLinkAuthDTO {
  /** User's email address */
  email: string;

  /** URL to redirect to after clicking the link */
  continueUrl: string;

  /** Additional action code settings */
  actionCodeSettings?: {
    /** Whether to handle the code in the app */
    handleCodeInApp?: boolean;
  };
}
